import React from "react";
import CustomButton from "../../../component/elements/CustomButton/CustomButton";
import BasicCustomTable from "../../../component/basicTable";
import { getServiceManagementPermissions } from "../../../utils/rolesAndPermissions";
import { useSelector } from "react-redux";

export default function TableCard({
  title,
  label,
  rows,
  onAdd,
  onDelete,
  onEdit,       // 🔥 Accept onEdit from parent
  columns,
  onViewAll
}) {
  const showViewAll = rows.length > 6;
  const visibleRows = showViewAll ? rows.slice(0, 6) : rows;

  const permissions = useSelector((state) => state.counter.permissions);
  const rolePermissions = permissions?.[0]?.permissions || [];

  // 🔥 Now includes canEdit
  const { canCreate, canDelete, canEdit } =
    getServiceManagementPermissions(rolePermissions);

  // 🔥 Keep your action-column removal logic intact, only based on delete permission
  const finalColumns = React.useMemo(() => {
    if (!canDelete) {
      return columns.filter((col) => col.field !== "action");
    }
    return columns;
  }, [canDelete, columns]);

  return (
    <div className="bg-[#eef6fe] rounded-2xl shadow-lg p-4 flex flex-col h-full">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-base font-semibold text-gray-800">{title}</h2>

        {canCreate && (
          <CustomButton
            onClick={onAdd}
            customeClass="gradient-button h-[35px] w-[50px]"
          >
            <span className="text-lg mr-1">+</span> Add
          </CustomButton>
        )}
      </div>

      <BasicCustomTable
        columns={finalColumns}
        rows={visibleRows}
        colorHeader={false}
        onDelete={onDelete}
        onEdit={onEdit}          
        tableName={label}
        canDelete={canDelete}
        canEdit={canEdit}      
      />

      {showViewAll && (
        <div className="flex justify-end mt-3">
          <button
            onClick={onViewAll}
            className="text-xs px-3 py-1 border border-gray-300 text-gray-700 rounded-full hover:bg-gray-100 transition"
          >
            View All
          </button>
        </div>
      )}
    </div>
  );
}
